// extracted by mini-css-extract-plugin
export default {"products":"sz-z","card":"tz-z","oosMessaging":"uz-z"};